import { useCurrentUser } from '../queries';

export const useUserGroup = (): string | undefined => {
  const { data: user } = useCurrentUser();
  return user?.primary_group;
};
